import(/* webpackMode: "eager" */ "/vercel/path0/app/(main)/industries/page.tsx");
